"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastReleaseNotesTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.LastReleaseNotesTransport = typebox_1.Type.Object({
    wayste: typebox_1.Type.Number(),
    adminPortal: typebox_1.Type.Number(),
});
//# sourceMappingURL=last-release-notes-transport.js.map